module.exports = __webpack_public_path__ + "assets/itunes.ab4dcfe4.svg";